import React from "react";
import { GoArrowLeft } from "react-icons/go";
import PatientTab from "./Utility/PatientTab";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiPrinter, FiDownload } from "react-icons/fi";
import { MdDelete } from "react-icons/md";

function PatientDetails() {
  const navigate = useNavigate();

  const patientDetails = `

  `

  return (
    <>
    <style>{patientDetails}</style>
      <div className="flex flex-col gap-5">
        <div className="flex items-center gap-4 flex-wrap">
          <button
            onClick={() => navigate("/dr-patients/list")}
            className="bg-[#fff] inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground size-10"
          >
            <GoArrowLeft />
            <span className="sr-only">Back</span>
          </button>
          <div>
            <h1 className="text-2xl lg:text-3xl font-bold tracking-tight mb-2">
              Patient Details
            </h1>
            <p className="text-muted-foreground">
              View and manage patient information.
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-5">
          <div className="rounded-lg border bg-card text-card-foreground shadow-sm lg:w-1/3">
            <div class="flex flex-col space-y-1.5 p-3 md:p-4 xxl:p-6 pb-2">
              <div class="flex justify-between items-start">
                <h2 class="text-xl xl:text-2xl font-semibold leading-tight mb-2 tracking-tight">
                  Patient Profile
                </h2>

                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  type="button"
                  className="inline-flex items-center justify-center shrink-0 gap-2 rounded-md text-sm font-medium ring-offset-background transition-colors   disabled:pointer-events-none disabled:opacity-50 hover:bg-gray-100 hover:text-black w-10 h-10"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-ellipsis h-4 w-4"
                  >
                    <circle cx="12" cy="12" r="1"></circle>
                    <circle cx="19" cy="12" r="1"></circle>
                    <circle cx="5" cy="12" r="1"></circle>
                  </svg>
                  <span className="sr-only">Actions</span>
                </button>

                <div
                  id="dropdown"
                  className="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44 dark:bg-gray-700"
                >
                  <ul
                    className="py-2 text-sm  font-semibold"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <a
                        href="#"
                        className="text-[#2b2b2b] flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white whitespace-nowrap"
                      >
                        <FiEdit className="mr-2 shrink-0" /> Edit Patient
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-[#2b2b2b] flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white whitespace-nowrap"
                      >
                        <FiPrinter className="mr-2 shrink-0" /> Print Profile
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-[#2b2b2b] flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white whitespace-nowrap"
                      >
                        <FiDownload className="mr-2 shrink-0" /> Export Data
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="flex items-center px-4 py-2 text-red-600 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white font-semibold whitespace-nowrap"
                      >
                        <MdDelete className="mr-2 shrink-0" /> Deactivate
                        Patient
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="text-sm text-muted-foreground">
                Patient ID: P12345
              </div>
            </div>

            <div class="p-3 md:p-4 xxl:p-6 space-y-6">
              <div class="flex flex-col items-center text-center">
                <span class="relative flex shrink-0 overflow-hidden rounded-full h-24 w-24 mb-4">
                  <img
                    class="aspect-square h-full w-full"
                    alt="John Smith"
                    src="./Images/avatar-26.png"
                  />
                </span>
                <h2 class="text-xl font-bold">John Smith</h2>
                <p class="text-muted-foreground">45 years • Male</p>
                <div class="flex items-center gap-2 mt-2">
                  <div class="inline-flex items-center rounded-full border px-1.5 whitespace-nowrap md:px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent text-white text-primary-foreground hover:bg-primary/80 bg-green-500">
                    Active
                  </div>
                  <div class="inline-flex items-center rounded-full border px-1.5 whitespace-nowrap md:px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-blue-500 text-blue-500">
                    O+
                  </div>
                </div>
              </div>
              <div
                data-orientation="horizontal"
                role="none"
                class="shrink-0 bg-border h-[1px] w-full"
              ></div>
              <div class="space-y-4">
                <div class="flex items-start gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-user shrink-0 h-5 w-5 text-muted-foreground mt-0.5"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <div class="space-y-1.5">
                    <h3 class="font-medium mb-3">Personal Information</h3>
                    <p class="text-sm">Date of Birth: 1978-05-15</p>
                    <p class="text-sm">Phone: +1 (555) 123-4567</p>
                    <p class="text-sm">Email: john.smith@example.com</p>
                    <p class="text-sm">
                      Address: 123 Main Street, Apt 4B, New York, NY 10001
                    </p>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-file-text shrink-0 h-5 w-5 text-muted-foreground mt-0.5"
                  >
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    <path d="M10 9H8"></path>
                    <path d="M16 13H8"></path>
                    <path d="M16 17H8"></path>
                  </svg>
                  <div>
                    <h3 class="font-medium mb-3">Medical Information</h3>
                    <div class="text-sm space-y-1.5">
                      <p>Blood Type: O+</p>
                      <p>Allergies: Penicillin, Peanuts</p>
                      <p>Conditions: Hypertension, Type 2 Diabetes</p>
                      <p>Primary Doctor: Dr. Sarah Johnson</p>
                    </div>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-receipt shrink-0 h-5 w-5 text-muted-foreground mt-0.5"
                  >
                    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
                    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
                    <path d="M12 17.5v-11"></path>
                  </svg>
                  <div class="space-y-1.5">
                    <h3 class="font-medium mb-3">Insurance Information</h3>
                    <p class="text-sm">Provider: Blue Cross Blue Shield</p>
                    <p class="text-sm">Policy Number: BCBS123456789</p>
                  </div>
                </div>
                <div class="flex items-start gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-user shrink-0 h-5 w-5 text-muted-foreground mt-0.5"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <div class="space-y-1.5">
                    <h3 class="font-medium mb-3">Emergency Contact</h3>
                    <p class="text-sm">Name: Mary Smith</p>
                    <p class="text-sm">Relationship: Wife</p>
                    <p class="text-sm">Phone: +1 (555) 987-6543</p>
                  </div>
                </div>
              </div>
              <div
                data-orientation="horizontal"
                role="none"
                class="shrink-0 bg-border h-[1px] w-full"
              ></div>
              <div class="flex justify-between text-sm text-muted-foreground">
                <span>Registered on: 10-Jun-2024</span>
                <span>Last Updated: 12-Jul-2025</span>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <PatientTab />
          </div>
        </div>
      </div>
    </>
  );
}

export default PatientDetails;
